import React, { FC, useEffect, useRef } from 'react';

import { useAudioStore } from 'state/sfx/audioStore';
import useSoundsPreloadStore from 'state/soundsPreloadStore';

export interface AtmosProps {
  // TODO: map api data to atmos sound
}

const Atmos: FC<AtmosProps> = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const preloaded = useSoundsPreloadStore(s => s.preloaded);
  const setAudio = useAudioStore(s => s.setAudio);
  const src = useSoundsPreloadStore(s => s.library?.['atmos_inner_city']?.src);
  const isAllowedAudio = useAudioStore(s => s.isAllowed);

  useEffect(() => {
    if (!preloaded) {
      return;
    }

    audioRef.current && setAudio('atmos', audioRef.current);
  }, [preloaded, setAudio]);

  return (
    <audio
      ref={audioRef}
      src={src}
      loop
      muted={!isAllowedAudio}
      preload="auto"
    />
  );
};
export default Atmos;
